import { useQuery } from "@apollo/client";
import { GetContactListDocument } from "@packages/apollo-hooks";
const useContactListQuery = (id) => useQuery(GetContactListDocument, {
    variables: {
        contactListId: id,
    },
    fetchPolicy: "cache-and-network",
});
export default useContactListQuery;
